// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17kmx","controls":"styles_controls__u4csQ","charLimit":"styles_charLimit__3n46f","input":"styles_input__2ZlX5","send":"styles_send__qcSSR"};